module.exports = __webpack_public_path__ + "static/media/protocolo.1a7a7aff.svg";